export default __webpack_public_path__ + "static/background-89e7350894b1649763d56b94c7a66e98.jpeg";